import { render, staticRenderFns } from "./TableObject.vue?vue&type=template&id=213b7294"
import script from "./TableObject.vue?vue&type=script&lang=js"
export * from "./TableObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports